export default "__VITE_ASSET__BhzVYMUV__"